import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function BlogList() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch("https://2uat7oq4p3xmd6xxksawogib5a0fbsbx.lambda-url.us-east-1.on.aws/get-all-blogs");
        if (!response.ok) throw new Error("Failed to fetch blogs");

        const data = await response.json();
        const sortedBlogs = data.blogs.sort((a, b) => b.blog_id - a.blog_id);
        setBlogs(sortedBlogs); // API should return { blogs: [...] }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div id="blog" className="bg-white p-6">
      <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
        Latest Blogs
      </p>

      {loading && <p className="text-gray-600 text-center">Loading blogs...</p>}
      {error && <p className="text-red-500 text-center">{error}</p>}

      <div className="overflow-x-auto whitespace-nowrap py-6">
        <div className="flex gap-6">
          {blogs.map((blog) => (
            <Link 
              key={blog.blog_id} 
              to={`/blog/${blog.blog_id}`} 
              className="bg-white w-80 p-5 rounded-lg shadow-lg hover:shadow-xl transition flex-shrink-0"
            >
              <h2 className="text-xl font-semibold text-gray-900">{blog.title}</h2>
              <div 
                dangerouslySetInnerHTML={{ __html: blog.content }} 
                className="text-gray-600 mt-2 overflow-hidden max-h-32 text-ellipsis"
                style={{ display: '-webkit-box', WebkitLineClamp: 6, WebkitBoxOrient: 'vertical' }}
              ></div>
              <p className="text-sm text-gray-500 mt-3">By {blog.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
